module.exports = __webpack_public_path__ + "static/cerca-af0aa0bd5e67a91077e3a39f4938e88c.jpg";